import { BigNumber } from '@ethersproject/bignumber'

const VOLUME_THRESHOLDS = [100, 500, 1_000, 5_000, 10_000, 50_000, 100_000, 500_000, 1_000_000, 5_000_000, 10_000_000]

export function getVolumeBucket(volume: BigNumber) {
  const threshold = VOLUME_THRESHOLDS.find((threshold) => volume.lte(threshold))
  if (threshold) {
    return `<= $${threshold.toLocaleString('en-US')}` // force comma separator
  }
  return `> $${VOLUME_THRESHOLDS[VOLUME_THRESHOLDS.length - 1].toLocaleString('en-US')}`
}
